import { Record } from '../transit'

const Mistake = new Record({
  count: 1,
  shortDescription: '',
  longDescription: '',
  type: '',
  prefix: '',
}, 'mistake')

export default Mistake



// WEBPACK FOOTER //
// ./src/common/results/Mistake.js